const env = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://api.baytbuddy.com/api/v1",
};

export default env;
